export default __webpack_public_path__ + "static/media/upload-local.b51389ac.webp";